export const RESOURCE_SLIDE_EDITOR_CONFIG = {
	bold: true,
	italics: true,
	underline: true,
	align: true,
	list: true,
	link: true,
	image: true,
	history: true,
	emoji: true,
};

// TODO: Do we need to migrate these boostrap@v4 class names stored in DB?
export const BOOTSTRAP_ASPECT_RATIOS_V4_TO_V5 = {
	'21by9': '21x9',
	'2by1': '2x1',
	'16by9': '16x9',
	'5by4': '5x4',
	'4by3': '4x3',
	'1by1': '1x1',
};

/**
 * The types of providers available for video resources,
 * stored in the "data" field of the resource.
 *
 * Library videos are stored in our library repo accessible
 * via the "data.video_id" field.
 *
 * URL videos are hardcoded links stored in the "data.src" field.
 */
export const RESOURCE_VIDEO_PROVIDERS = {
	LIBRARY: 'library',
	URL: 'url',
};
